// Console-relative path whitelist — the ONE check every operator- or
// backend-authored "open this in the console" target passes before it may
// become a rendered href. Shared by the notifications inbox
// (data.actionUrl) and the announcements board (actionUrl); the backend
// refuses the same shapes at write time, so a bad row can never turn a
// console surface into a redirect off the product.
//
// Accepted: `/path`, `/path?query`, `/path#frag` — a leading slash followed
// by no whitespace and no backslash.
// Rejected: absolute URLs (`https://…`, `javascript:…`), protocol-relative
// (`//host/…` — an absolute URL in disguise), backslash variants
// (`/\host/…` — browsers collapse `\` to `/`, making it `//host/…` the
// moment the href leaves the router), bare paths, and any whitespace or
// control char.
import { isPublicPath } from './publicLocale'

export function toConsolePath(raw: unknown): string | null {
  if (typeof raw !== 'string') return null
  const path = raw.trim()
  if (!/^\/[^\s\\]*$/.test(path) || path.startsWith('//')) return null
  return path
}

// 落地页公告栏的收窄白名单 —— 与 `toConsolePath` 同一个语法闸门，再加一道公开面闸门。
//
// 为什么要第二道：公告的 `actionUrl` 由运营在控制台写，`toConsolePath` 只保证它是
// 一个站内路径。而落地页公告栏在**登录之前**渲染，指向 `/dashboard` 的条目对匿名
// 读者是一条死链（撞 AuthGate 回 /login，点的人不知道自己被登录墙拦了）。控制台侧
// 的收件箱与公告管理板仍然需要深链，所以收窄只发生在这个导出函数里，不动
// `toConsolePath` 本身 —— 后者是控制台面的真源。
//
// /en/* 也放行：英文落地页上的公告 CTA 指向 `/en/docs` 是正常运营写法
// （`isPublicPath` 认这一族；`PublicLink` 自己再做语言前缀归一）。
export function toPublicPath(raw: unknown): string | null {
  const path = toConsolePath(raw)
  if (path === null) return null
  const pathname = path.split(/[?#]/, 1)[0] ?? '/'
  return isPublicPath(pathname) ? path : null
}
